import ContactUs from '../sections/contact-us/ContactUs';
import App from '../App';

window.App = App;
window.Section = ContactUs;


